export const rootElement = document.getElementById('root');
export const fieldHeight = '56px';
